export default "__VITE_ASSET__YqWGdXzB__"